<template>
  <div>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-container>
      <v-row>
        <v-col sm="12" md="6" lg="9">
          <TaskHeader
            :task="task"
            :estUnit="estimationUnit"
            @update-task-dates="handleTaskDates"
            @update-actual-hours="handleTaskActualTime"
          />
        </v-col>
        <v-col sm="12" md="6" lg="3"  v-if="hasPermission('task.assignee_section_view')">
          <TaskMember
            v-if="hasPermission('task.assignee_section_view')"
            :initialStatus="task.status"
            :project="task"
            :projectMembersArray="this.members"
            :multiUser="taskMultiUser"
            @update-status="handleUpdateStatus"
            @members-add="handleAddMembers"
            @members-delete="handleDeleteMembers"
          ></TaskMember>
        </v-col>

        <v-col sm="12" md="6" v-if="hasPermission('document.task_document_upload') || hasPermission('document.task_document_download')">
          <Attachments
            v-if="hasPermission('document.task_document_upload') || hasPermission('document.task_document_download')"
            :project="task"
            :taskData="true"
            @documents-upload="handleDocumentsUpload"
            @documents-download="handleDocumentsDownload"
            @documents-delete="handleDocumentsDelete"
          />
        </v-col>
        <v-col sm="12" md="6">
          <RecentActivity
            v-if="hasPermission('task.recent_activity_view')"
            :activityLogs="task.task_logs"
          />
        </v-col>

        <v-col cols="12" v-if="hasPermission('task.message_view')">
          <comments
            v-if="hasPermission('task.message_view')"
            :commentsData="task.task_comments"
            @add-comments="handleAddComments"
            @delete-comments="handleDeleteComments"
          />
        </v-col>
      </v-row>
    </v-container>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { ProjectService } from "@/services/project-service.js";
import Attachments from "@/components/shared/Attachments.vue";
import TaskHeader from "@/components/shared/TaskHeader.vue";
import Comments from "@/components/shared/Comments.vue";
import { fileService } from "@/config/file-service.js";
import RecentActivity from "@/components/shared/RecentActivity.vue";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { TaskService } from "@/services/task-service.js";
import TaskMember from "@/components/shared/TaskMember.vue";
import { checkError } from "@/config/errors.js";
import { SettingsService } from "../../services/setting-service.js";

export default {
  name: "TaskDetails",

  components: {
    Attachments,
    TaskHeader,
    Comments,
    RecentActivity,
    Alert,
    Snackbars,
    TaskMember,
  },

  data: () => ({
    task: {},
    members: [],
    defaultImage: require("@/assets/img/avatar.svg"),
    errors: null,
    snackbar: false,
    succesMsg: "",
    taskMultiUser: false,
    estimationUnit: 'Hours',
  }),

  mounted() {
    this.getProjectInfo(), this.getProjectMembers();
    this.getProjectSettings();
  },

  computed: {
    ...mapGetters({
      member: "profile",
      hasPermission: "hasPermission",
    }),
  },

  methods: {
    getProjectInfo() {
      this.loading = true;
      this.onDismissed();
      TaskService.getTaskInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.task = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getProjectMembers() {
      this.loading = true;
      this.onDismissed();
      TaskService.getMembers(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          this.members = response.data.data;
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleTaskCreated(newTask) {
      this.onDismissed();
      ProjectService.createTask(this.$route.params.uuid, newTask)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Task Created Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleDocumentsUpload(documents) {
      this.onDismissed();
      TaskService.documentUpload(this.$route.params.uuid, documents)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Document Uploaded Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleDocumentsDownload(uuid) {
      this.onDismissed();
      TaskService.downloadDocuments(uuid)
        .then((response) => {
          const contentType = response.headers["content-type"];
          const matches = contentType.match(/filename="(.+?)\.(.+?)"/);
          if (matches && matches.length === 3) {
            const fileName = matches[1];
            const fileExtension = matches[2];
            fileService.downloadFile(
              response.data,
              "",
              fileExtension,
              fileName
            );
            this.succesMsg = "Document Downloaded Successfully";
            this.snackbar = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          error.response.data;
          this.errors = ["File Not Found"];
        });
    },
    handleDocumentsDelete(document) {
      let fd = new FormData();
      this.onDismissed();
      fd.append("uuid", document);
      TaskService.deleteDocument(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Document Deleted Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleAddComments(comment) {
      let fd = new FormData();
      this.onDismissed();
      fd.append("comment", comment);
      TaskService.addTaskComments(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Comment Added Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleDeleteComments(comment, permission) {
      let fd = new FormData();
      this.onDismissed();
      fd.append("uuid", comment);
      fd.append("auth_permission", permission);
      TaskService.deleteTaskComments(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Comment Deleted Successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    handleUpdateStatus(status) {
      let fd = new FormData();
      fd.append("status", status);
      this.onDismissed();
      TaskService.updateTaskStatus(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleTaskDates(dates) {
      this.errors = null;
      this.onDismissed();
      TaskService.updateTaskDates(this.$route.params.uuid, dates)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = "Task dates updated successfully";
            this.snackbar = true;
          }
          this.getProjectInfo();
          this.$emit("update-task-dates", { success: response.data });
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.$emit("update-task-dates", { error: errorOutput });
        });
    },

    handleAddMembers(members) {
      let fd = new FormData();
      fd.append("member_id", members);
      this.onDismissed();
      TaskService.addTaskMembers(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (Object.keys(members).length !== 0 && response.data) {
            this.succesMsg = "Member Added Successfully";
            this.snackbar = true;
          } else {
            this.succesMsg = "Members are not Selected";
            this.snackColor = "warning";
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleDeleteMembers(member) {
      let fd = new FormData();
      fd.append("member_id", member);
      this.onDismissed();
      TaskService.deleteTaskMembers(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
          }
          this.getProjectInfo();
          this.$emit("update-actual-hours", { success: response.data });
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.$emit("update-actual-hours", { error: errorOutput });
        });
    },
    handleTaskActualTime(hours) {
      let fd = new FormData();
      fd.append("actual_hours", hours);
      this.onDismissed();
      TaskService.updateTaskActualHours(this.$route.params.uuid, fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
          }
          this.getProjectInfo();
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getProjectSettings() {
      SettingsService.getProjectSettings()
        .then((response) => {
          const settings = response.data.data;

          const multiUserSetting = settings.find(
            (setting) => setting.key === "tasks_muti_user_enable"
          );
          if (multiUserSetting) {
            let value = multiUserSetting.value;
            if (value === "true" || value === "false") {
              value = value === "true";
            }
            this.taskMultiUser = value;
          }

          const estimationUnitSetting = settings.find(
            (setting) => setting.key === "estimation_unit"
          );
          if (estimationUnitSetting) {
            let value = estimationUnitSetting.value;
            if (value) {
              this.estimationUnit = value;
            } else {
              this.estimationUnit = "Hours";
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errors = checkError.errorFormatting(error.response.data);
        });
    },
    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
